import * as React from "react"

import { OfficeDateField } from './OfficeDateField';

import { cn } from "../../lib/utils"

/* Input V3 — refined neutral, subtle ring on focus. */
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  if (type === 'date' || type === 'datetime-local') return <OfficeDateField {...props} type={type} className={className} ref={ref} />;
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-border bg-secondary/60 px-3 py-1",
        "text-[13.5px] text-foreground placeholder:text-muted-foreground/70",
        "transition-[border-color,background-color,box-shadow] duration-150",
        "file:border-0 file:bg-transparent file:text-[13px] file:font-medium file:text-foreground",
        "focus-visible:outline-none focus-visible:border-foreground/30 focus-visible:bg-card focus-visible:ring-1 focus-visible:ring-ring/40",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "md:text-[13.5px]",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
